import client from './client'

// Get unread notifications count
export const getUnreadCount = async () => {
  const response = await client.get('/notifications/unread-count')
  return response.data
}

// Get paginated list of notifications
export const getNotifications = async ({ page = 1, perPage = 25, unreadOnly = false } = {}) => {
  const params = new URLSearchParams()
  params.append('page', page)
  params.append('per_page', perPage)
  if (unreadOnly) params.append('unread_only', 'true')

  const response = await client.get(`/notifications?${params.toString()}`)
  return response.data
}

// Mark notifications as read (pass array of ids or null for all)
export const markAsRead = async (notificationIds = null, markAll = false) => {
  const response = await client.post('/notifications/mark-read', {
    notification_ids: notificationIds,
    mark_all: markAll
  })
  return response.data
}

// Mark single notification as read
export const markSingleAsRead = async (id) => {
  const response = await client.post(`/notifications/${id}/read`)
  return response.data
}

// Delete notification
export const deleteNotification = async (id) => {
  const response = await client.delete(`/notifications/${id}`)
  return response.data
}

// Get link to navigate to based on notification type and entity
export const getNotificationLink = (notification) => {
  if (!notification.entity_type || !notification.entity_id) {
    return null
  }

  switch (notification.entity_type) {
    case 'incident':
      return `/incidents/${notification.entity_id}`
    case 'dimension_request':
      return '/dimension-requests'
    case 'order':
      return `/orders/${notification.entity_id}`
    default:
      return null
  }
}

// Notification type names
export const NOTIFICATION_TYPE_NAMES = {
  dimension_request_created: 'Запрос ВГШ',
  dimension_request_approved: 'ВГШ одобрен',
  dimension_request_rejected: 'ВГШ отклонён',
  incident_created: 'Новый инцидент',
  incident_assigned: 'Инцидент назначен',
  incident_message: 'Сообщение',
  incident_status_changed: 'Статус инцидента',
  order_created: 'Новый заказ',
  order_status_changed: 'Статус заказа'
}

// Notification type icons (lucide-react icon names)
export const NOTIFICATION_TYPE_ICONS = {
  dimension_request_created: 'Ruler',
  dimension_request_approved: 'Check',
  dimension_request_rejected: 'X',
  incident_created: 'AlertCircle',
  incident_assigned: 'User',
  incident_message: 'MessageSquare',
  incident_status_changed: 'RefreshCw',
  order_created: 'ShoppingCart',
  order_status_changed: 'Truck'
}

// Notification type colors
export const NOTIFICATION_TYPE_COLORS = {
  dimension_request_created: 'bg-purple-100 text-purple-600',
  dimension_request_approved: 'bg-green-100 text-green-600',
  dimension_request_rejected: 'bg-red-100 text-red-600',
  incident_created: 'bg-orange-100 text-orange-600',
  incident_assigned: 'bg-blue-100 text-blue-600',
  incident_message: 'bg-blue-100 text-blue-600',
  incident_status_changed: 'bg-gray-100 text-gray-600',
  order_created: 'bg-green-100 text-green-600',
  order_status_changed: 'bg-yellow-100 text-yellow-600'
}
